import 'core-js/stable/global-this';
//Sass
import React from 'react';
import './Sass/main.sass'
import './Sass/includes/Components/modules/CE20.sass'
import './Sass/includes/Components/modules/CE41.sass'


import { createRoot } from 'react-dom/client';
import SelectComponent from 'Components/Atoms/SelectComponent/SelectComponent';

const container = document.getElementById('react_landing_bancos');
const root = createRoot(container);
// window.JSP_DATA = {
//         myKey: "${yourJspVariable}",
//         userRole: "${user.role}"
//     };

root.render(
  <React.StrictMode>
     <SelectComponent />
  </React.StrictMode>
);
